import { namespacer } from "util/namespace";
import { TW_API_URL } from "config";

const NAMESPACE = "PAGES_TEAMS";

export const GET_PLAYERS_REQUEST_START = namespacer(
  NAMESPACE,
  "GET_PLAYERS_REQUEST_START"
);
export const GET_PLAYERS_REQUEST_SUCCESS = namespacer(
  NAMESPACE,
  "GET_PLAYERS_REQUEST_SUCCESS"
);
export const GET_PLAYERS_REQUEST_ERROR = namespacer(
  NAMESPACE,
  "GET_PLAYERS_REQUEST_ERROR"
);

export function getPlayersRequestStart() {
  return {
    type: GET_PLAYERS_REQUEST_START,
  };
}

export function getPlayersRequestSuccess(players) {
  return {
    type: GET_PLAYERS_REQUEST_SUCCESS,
    players,
  };
}

export function getPlayersRequestError(error) {
  return {
    type: GET_PLAYERS_REQUEST_ERROR,
    error,
  };
}

export function getPlayersRequest(season) {
  return (dispatch) => {
    dispatch(getPlayersRequestStart());

    const url = `${TW_API_URL}/twl/players?season=${season}`;

    return fetch(url)
      .then((data) => data.json())
      .then((data) =>
        data.map((p) => ({
          id: p.fcName.toLowerCase(),
          captain: p.teamRole === "Captain",
          assistant: p.teamRole === "Assistant",
          teamRole: p.teamRole,
          name: p.fcName,
          // orderPicked: p.fnPickOrder,
          // ratings: {
          //   total: p.fnStars,
          //   twld: p.fnWBStars,
          //   twlj: p.fnJavStars,
          //   twlb: p.fnBaseStars,
          // },
          fnTeamID: p.fnTeamID,
          leagueType: p.fnLeagueType,
        }))
      )
      .then((players) => {
        dispatch(getPlayersRequestSuccess(players));
      })
      .catch((error) => {
        dispatch(getPlayersRequestError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/pages/teams.js